// CountBadge component for UI Component Library
// Created as part of ENG2-1691: Phase 3 - Ticket 3.1

import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { tokens } from '../../../styles/tokens'
import { CountBadgeProps, CountBadgeVariant } from './badge.types'

// Color configurations for each variant
const variantColors: Record<CountBadgeVariant, { bg: string; text: string }> = {
  default: {
    bg: tokens.colors.grey[200],
    text: tokens.colors.grey[600],
  },
  primary: {
    bg: tokens.colors.primary[300],
    text: tokens.colors.primary[900],
  },
}

// Styled badge container
const BadgeContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'badgeVariant',
})<{ badgeVariant: CountBadgeVariant }>(({ badgeVariant }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 20,
  height: 20,
  padding: '2px 6px',
  borderRadius: 10,
  backgroundColor: variantColors[badgeVariant].bg,
}))

// Styled count text
const CountText = styled('span', {
  shouldForwardProp: (prop) => prop !== 'badgeVariant',
})<{ badgeVariant: CountBadgeVariant }>(({ badgeVariant }) => ({
  fontSize: 11,
  fontWeight: 600,
  color: variantColors[badgeVariant].text,
  lineHeight: 1,
}))

export const CountBadge: React.FC<CountBadgeProps> = ({
  count,
  variant = 'default',
  max = 99,
  className,
}) => {
  const displayCount = count > max ? `${max}+` : count.toString()

  return (
    <BadgeContainer badgeVariant={variant} className={className}>
      <CountText badgeVariant={variant}>
        {displayCount}
      </CountText>
    </BadgeContainer>
  )
}

CountBadge.displayName = 'CountBadge'

export default CountBadge
